import React from 'react';

const EngineeringLoadAnimation = () => {
  return (
    <div className="engineering-loading-animation">
    </div>
  );
};

export default EngineeringLoadAnimation;